var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('content-link-edit',{attrs:{"content":_vm.content,"back-route":{ name: 'system-content-links' }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/content/links/edit.vue?vue&type=template&id=359b6bc8
// module id = Dhwn
// module chunks = 0